import CallingCard from '../../../Components/CallingCard';
import Carousel from '../../../Components/Carousel';
import { Card } from '../../../Components/ui';
import { renderTestimonials } from '../../../Helpers/renderTestimonials';

import landing_page_card_images from '../../../../../../public/js/landing_page_card_images.json';

const CallToActionFooter = () => {
    const { images } = landing_page_card_images;
    const testimonials = window?.testimonials || [];
    const isCallCenterAvailable = window?.call_center_available ?? true;
    const phone = window?.lead_phone || '';
    return (
        <div id="my-quote-footer">
            <div id="call-to-action-footer">
                <div id="card-container">
                    <Card showContent={true}>
                        <div id="card-images-wrapper">
                            {images.map(({ key, src, width, height }) => (
                                <img
                                    key={key}
                                    src={src}
                                    alt={key}
                                    width={width}
                                    height={height}
                                    className="card-image"
                                    loading="lazy"
                                />
                            ))}
                        </div>
                    </Card>
                    {testimonials.length > 0 && <Carousel content={testimonials} renderItem={renderTestimonials} />}
                </div>
                {isCallCenterAvailable && phone && (
                    <CallingCard>
                        <h4>Want faster coverage?</h4>
                        <a href={`tel:${phone}`}>
                            <b className="call">Call us at {phone}</b>
                        </a>
                    </CallingCard>
                )}
            </div>
        </div>
    );
};

export default CallToActionFooter;
